<template>
  <el-dialog
    title="驳回理由"
    :visible.sync="dialogVisible"
    width="30%">
    <el-select v-model="form.reason" placeholder="请选择驳回理由">
      <el-option
        v-for="item in reasonArray"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
    <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="save">确 定</el-button>
    </span>
  </el-dialog>
</template>


<script>
  import {returnData} from '@/api/set/externaldept';

  export default {
    name: "DataContactEdit",
    data() {
      return {
        dialogVisible: false,
        reasonArray: [{
          value: '信息不全',
          label: '信息不全'
        }, {
          value: '重复注册',
          label: '重复注册'
        }],
        form: {
          reason: '',
          linkmantel: '',
          unitguid: '',
          linkman: ''
        },
        linkmanArray: []
      }
    },
    methods: {
      show(row) {
        this.dialogVisible = true;
        this.form.linkmantel = JSON.parse(row.yecontent).linkmantel;
        if (row.uguid && row.uguid != '客户注册') {
          this.form.linkmantel = '';//后台人员注册的不用发送 驳回短信
        }
        this.form.unitguid = row.unitguid;
        this.form.linkman = JSON.parse(row.yecontent).linkman;
        this.linkmanArray = JSON.parse(row.yecontent);
      },
      save() {
        if (!this.form.reason) {
          this.$message({
            type: 'error',
            message: '请选择驳回理由'
          });
          return;
        }
        let obj = {
          unitguid: this.form.unitguid,
          mobile: this.form.linkmantel,
          name: this.form.linkman,
          code: this.form.reason
        }
        returnData({text: JSON.stringify(obj)}).then(response => {
          if (response.data.code == 0) {
            this.$message({
              message: '驳回成功',
              type: 'success'
            })
            this.dialogVisible = false;
            //刷新列表
            this.$emit('bindGrid');
          } else {
            this.$message({
              message: response.data.msg,
              type: 'error'
            })
          }
        })
      }
    },
    mounted() {
    },
    components: {}
  }
</script>



// WEBPACK FOOTER //
// src/components/workflow/waitaudit/ReasonDialog.vue